import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "title"
}
const _hoisted_2 = { class: "content" }

import { computed, onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import store from "@/store";

import { toast } from "@/common/utils/toast";
import { base64ToFile } from "@/common/utils/files";

import { employeModelCSV } from "@/common/api/rest/employee";
import {
  evaluationEmployeeList,
  evaluationEmployeeCreate,
  evaluationEmployeeDelete,
} from "@/common/api/rest/evaluation/employee";

import { employeeCreate } from "@/common/api/rest/employee";

import type {
  EmployeeListType,
  EmployeePayloadType,
} from "@/common/types/employee";
import type { EvaluationType } from "@/common/types/evaluation";

import { fileUploadForm, employeeForm, searchEmployee } from "@/components";
import { baseConfirm, baseModal, baseTable } from "@/common/components";

interface SelectItemType {
  employee_id: string;
  name: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'employees',
  props: {
    data: {},
    width: { default: "100%" },
    showTitle: { type: Boolean, default: true }
  },
  emits: ["update-data"],
  setup(__props: any, { emit: __emit }) {

const { t } = useI18n();

const emit = __emit;

const props = __props;

const tableHeader = computed(() => [
  { key: "first_name", label: t("common.labels.name") },
]);

const tableData = ref<EmployeeListType[]>([]);

const selected = ref<any>(null);
const selecteds = ref<any[]>([]);
const selectedItem = ref<SelectItemType | null>(null);
const employeeData = ref<EmployeePayloadType | null>(null);

const limit = ref<number>(5);
const page = ref<number>(0);
const pages = ref<number>(0);
const search = ref<string>("");
const searched = ref<number>(0);
const total = ref<number>(0);

const showModalAdd = ref(false);
const showConfirmDel = ref(false);
const showModalNew = ref(false);

function fetchData() {
  if (!props.data) return;

  evaluationEmployeeList(props.data.account_id, {
    evaluation_id: props.data.evaluation_id,
    limit: limit.value,
    page: page.value,
    search: search.value,
  })
    .then((response) => {
      const { success, data, message } = response;

      if (success) {
        tableData.value = data.list;
        page.value = data.infos.page;
        pages.value = data.infos.pages;
        total.value = data.infos.total;
        searched.value = data.infos.count;
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function update() {
  emit("update-data");
}

function add() {
  showModalAdd.value = true;
  selectedItem.value = null;
}

function addCancel() {
  showModalAdd.value = false;
  selectedItem.value = null;
}

function addSelect(data: any[]) {
  selecteds.value = data;
}

function addConfirm() {
  if (!props.data || !selecteds.value.length) return;

  showModalAdd.value = false;

  const promises = selecteds.value.map((sl) =>
    evaluationEmployeeCreate(props.data.account_id, {
      evaluation_id: props.data.evaluation_id,
      employee_id: sl.employee_id,
    }),
  );

  Promise.all(promises)
    .then((responses) => {
      responses.forEach((response) => {
        const { success, message } = response;
        if (success) {
          toast({ message: message, type: "success" });
          fetchData();
          update();
        } else {
          toast({ message: message, type: "error" });
        }
      });
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function remove(data: EmployeeListType) {
  selected.value = data;
  showConfirmDel.value = true;
}

function removeCancel() {
  selected.value = null;
  showConfirmDel.value = false;
}

function removeConfirm() {
  if (!props.data || !selected.value) return;

  store.commit("SET_LOADING", true);

  evaluationEmployeeDelete(props.data.account_id, selected.value.item_id)
    .then((response) => {
      const { success, message } = response;

      if (success) {
        fetchData();
        removeCancel();
        update();
        toast({ message: message, type: "success" });
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    })
    .finally(() => {
      store.commit("SET_LOADING", false);
    });
}

function newRegister(name: string) {
  showModalNew.value = true;
  showModalAdd.value = false;
  selected.value = null;
  employeeData.value = { name } as any;
}

function newRegisterCancel() {
  showModalNew.value = false;
  selected.value = null;
  employeeData.value = null;
}

function newRegisterConfirm() {
  if (!props.data?.company) return;

  showModalNew.value = false;

  employeeCreate(
    props.data.account_id,
    props.data?.company?.company_id,
    employeeData.value as any,
  )
    .then((response) => {
      const { success, data, message } = response;

      if (success) {
        evaluationEmployeeCreate(data.account_id, {
          evaluation_id: props.data.evaluation_id,
          employee_id: data.employee_id,
        })
          .then(() => {
            toast({ message: message, type: "success" });
          })
          .finally(() => {
            fetchData();
            update();
          });
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function searchItem(value: string) {
  search.value = value;
  fetchData();
}

function changePage(value: number) {
  page.value = value;
  fetchData();
}

onMounted(() => {
  fetchData();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["tab-component", { width: __props.width }])
  }, [
    (__props.showTitle)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_unref(t)("common.labels.employees")), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(baseTable), {
        header: tableHeader.value,
        data: tableData.value,
        limit: limit.value,
        page: page.value,
        pages: pages.value,
        total: total.value,
        searched: searched.value,
        options: true,
        add: !!__props.data?.company,
        del: true,
        "onChange:page": changePage,
        onSearching: searchItem,
        "onBtn:add": _cache[0] || (_cache[0] = ($event: any) => (add())),
        "onBtn:del": remove
      }, {
        first_name: _withCtx(({ data }) => [
          _createElementVNode("span", null, _toDisplayString(data.name), 1)
        ]),
        _: 1
      }, 8, ["header", "data", "limit", "page", "pages", "total", "searched", "add"])
    ]),
    _createVNode(_unref(baseModal), {
      show: showModalAdd.value,
      title: 
        _unref(t)('common.labels.add', {
          concat: _unref(t)('common.labels.employee'),
        }).toUpperCase()
      ,
      "show-button-confirm": true,
      "button-confirm": _unref(t)('common.labels.add'),
      "button-close": _unref(t)('common.labels.cancel'),
      onClose: _cache[1] || (_cache[1] = ($event: any) => (addCancel())),
      onConfirm: _cache[2] || (_cache[2] = ($event: any) => (addConfirm()))
    }, {
      content: _withCtx(() => [
        _createVNode(_unref(searchEmployee), {
          "account-id": __props.data?.account_id,
          "company-id": __props.data?.company?.company_id,
          add: true,
          ids: tableData.value?.map((item) => item.employee_id),
          onUpdateData: addSelect,
          "onNew:register": newRegister
        }, null, 8, ["account-id", "company-id", "ids"])
      ]),
      _: 1
    }, 8, ["show", "title", "button-confirm", "button-close"]),
    _createVNode(_unref(baseModal), {
      show: showModalNew.value,
      title: 
        _unref(t)('common.labels.add', {
          concat: _unref(t)('common.labels.employee'),
        }).toUpperCase()
      ,
      "show-button-confirm": true,
      "button-confirm": _unref(t)('common.labels.add'),
      "button-close": _unref(t)('common.labels.cancel'),
      onClose: _cache[4] || (_cache[4] = ($event: any) => (newRegisterCancel())),
      onConfirm: _cache[5] || (_cache[5] = ($event: any) => (newRegisterConfirm()))
    }, {
      content: _withCtx(() => [
        _createVNode(_unref(employeeForm), {
          data: employeeData.value,
          onUpdateData: _cache[3] || (_cache[3] = ($event: any) => (employeeData.value = $event))
        }, null, 8, ["data"])
      ]),
      _: 1
    }, 8, ["show", "title", "button-confirm", "button-close"]),
    _createVNode(_unref(baseConfirm), {
      show: showConfirmDel.value,
      title: 
        _unref(t)('common.labels.remove', {
          concat: _unref(t)('common.labels.employee'),
        }).toUpperCase()
      ,
      message: 
        _unref(t)('common.texts.remove_message', {
          concat: selected.value?.name,
        })
      ,
      onCancel: removeCancel,
      onConfirm: removeConfirm
    }, null, 8, ["show", "title", "message"])
  ], 2))
}
}

})